import { BrandTaxQuery } from './brand-tax-query';
import { ApplyBrandTaxMutation } from './apply-brand-tax-mutation';
import { UpdateBrandTaxMutation } from './update-brand-tax-mutation';
export var endpoints = {
    brandTaxQuery: new BrandTaxQuery(),
    applyBrandTaxMutation: new ApplyBrandTaxMutation(),
    updateBrandTaxMutation: new UpdateBrandTaxMutation(),
};
export * from './brand-tax-query';
export * from './apply-brand-tax-mutation';
export * from './update-brand-tax-mutation';
